// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"476":"4c8486f1","787":"cee8aa2f"}[chunkId] + ".chunk.js";
};